<template>
    <div class="forum-loader">
        <Loader></Loader>
    </div>
</template>

<script>
    // ForumLoader: a loading animation stylized for the forum.

    // TODO: the various ForumLoader* components shuould be condensed into this
    // one component by using a prop.

    import Loader from '../../widgets/Loader';

    export default {
        components: {
            Loader,
        },
    }
</script>

<style lang="scss" scoped>
    .forum-loader {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 20px;
    }
</style>

<style lang="scss">
    .forum-loader {
        .loader {
            .loading-image-wrapper {
                width: 100px;
                height: 100px;
                .loading-image {
                    width: 100px;
                    height: 100px;
                    top: auto;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// loader.vue?1e660012